import { Grid, CircularProgress } from '@mui/material';
import { withStyles } from '../mui-styles-bridge.js';
import {
  addPageData,
  goBackToANY,
  unmountForm,
  formLoading,
  goBackToPrevious,
  fetchNextPageData,
  addPageDataCalendar,
  addPageDataTable,
  fetchFormComments,
  updateFormState,
} from '../store/form/actions';
import { dynamicRender } from './form_tools/dynamicRender';
import './Form.css';
import { v4 as uuid } from 'uuid';
import axios from 'axios';
import config from '../config';
import FadeIn from '../components/FadeIn';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { styles } from './form_tools/formStyle';
import { uniqueNamesGenerator } from 'unique-names-generator';
import FormSkeletonLoader from './FormSkeletonLoader';
import ConversationalSkeletonLoader from './component/ConversationalRenderer/ConversationalSkeletonLoader';
import NavigationMenu from './component/NavigationSidebar/NavigationMenu';
import SubmitButtons from './component/SubmitButtons';
import CoverImage from './CoverImage';
import { Helmet } from 'react-helmet';
import { parsePlaceholder } from './utils/detectAnswer';
import { getUrlPrepopulatedAnswerData } from './utils/urlPrepopulation';
import SubmissionReceipt from './SubmissionReceipt';
import FormSubmissionHandler from './handlers/FormSubmissionHandler';
import FileUploadHandler from './handlers/FileUploadHandler';
import FormValidator from './validators/FormValidator';
import ComponentRenderer from './renderers/ComponentRenderer';
import AutoSaveManager from './managers/AutoSaveManager';
import AuthenticationManager from './auth/AuthenticationManager';
import FormDataManager from './managers/FormDataManager';
import NavigationHandler from './handlers/NavigationHandler';
import withNavigate from '../utils/withNavigate';
import ErrorHandler from './handlers/ErrorHandler';
import {
  UNIQUE_NAMES_GENERATOR_CONFIG,
  AUTH_STATES,
  RECEIPT_STATES,
  API_ENDPOINTS,
  DEFAULT_VALUES,
  UI_TEXT,
  SIZE_CONSTANTS,
  QUERY_PARAMS,
  DEFAULT_TIMEZONE,
} from './constants/FormConstants';
import AuthenticationGate from './component/AuthenticationGate';
import FormStatusBanners from './component/FormStatusBanners';
import FormHeaderComponent from './component/FormHeader/FormHeaderComponent';
import FormQuestionRenderer from './component/FormQuestion/FormQuestionRenderer';
import ConversationalRenderer from './component/ConversationalRenderer/ConversationalRenderer';
import FormFooterComponent from './component/FormFooter/FormFooterComponent';
import FormNavigationButtons from './component/FormNavigation/FormNavigationButtons';
import FormDialogManager from './component/FormDialogs/FormDialogManager';
import FormLayoutWrapper from './component/FormLayout/FormLayoutWrapper';
import RequiredFieldsSnackbar from './component/RequiredFieldsSnackbar';
import TestModeControls from './component/TestModeControls';

const uniqueNamesGeneratorConfig = UNIQUE_NAMES_GENERATOR_CONFIG;

class Form extends Component {
  state = {
    isTest: this.props.match.params.test_id !== undefined,
    answer: {},
    idToken: '',
    form_id: '',
    submMsg: '',
    password: '',
    form_logo: '',
    sended: false,
    AlertD: false,
    form_title: '',
    currentStep: 0,
    loading: false,
    form_oauth2: '',
    authError: null,
    finished: false,
    required_list: [],
    required_list_table: {},
    saveDialog: false,
    submissionId: null,
    trueCanReadOnly: false,
    canReadOnly: false,
    isSingleUse: false,
    canInitData: false,
    projectSessionId: '',
    authState: AUTH_STATES.LOADING,
    pageProcessing: false,
    receiptState: RECEIPT_STATES.HIDDEN,
    canAddSubmission: false,
    canSaveSubmission: true,
    canSubmitSubmission: true,
    canEditSubmission: false,
    parentThreadId: null,
    numRows: null,
    exportType: null,
    tableCells: null,
    threadId: null,
    waitingStateThreadId: null,
    waitingStateParentThreadId: null,
    AlertMsg: { message: '', status: 200 },
    pagesMeta: [],
    openMainMenu: false,
    previewMode: false,
    coverImage: '',
    pagesErrorDialog: false,
    pagesError: [],
    linkedComponent: false,
    redirectToExternalUrl: false,
    redirectUrl: '',
    timezone: DEFAULT_TIMEZONE,
    username: DEFAULT_VALUES.ANONYMOUS_USERNAME,
    testResult: null,
    branding: true,
    isSubmitting: false,
    hasBeenSubmitted: false,
    initialLoad: true,
    formType: null,
    displayMode: 'classic',
    displayModeFromUrl: false,
    displayModeKnown: false,
    hasAutoSaveEnabled: false,
    lastSaved: null,
    isTerminated: false,
    showResubmitDialog: false,
    showSubmissionDialog: false,
    formFailures: {},
    showFailedSubmissionDialog: false,
    showRequiredFieldsSnackbar: false,
    isValidationEnabled: true,
  };

  visitedPages = new Set();

  constructor(props) {
    super(props);

    this.submissionHandler = new FormSubmissionHandler(this);
    this.fileUploadHandler = new FileUploadHandler(this);

    this.componentRenderer = new ComponentRenderer(this);
    this.autoSaveManager = new AutoSaveManager(this);

    this.dataManager = new FormDataManager(this);
    this.navigationHandler = new NavigationHandler(this);
    this.errorHandler = new ErrorHandler(this);

    AuthenticationManager.setupAuthHub(
      AuthenticationManager.processIdToken,
      this.initData.bind(this),
      this.setState.bind(this)
    );

    AuthenticationManager.getCurrentUserInfo(
      this.setState.bind(this),
      uniqueNamesGenerator,
      uniqueNamesGeneratorConfig
    );

    this.visitedPages.add(0);
  }

  handleToPage = (index) => {
    return this.navigationHandler.handleToPage(index);
  };

  submitForm = async (reqId, answer_data) => {
    return this.submissionHandler.submitForm(reqId, answer_data);
  };

  handleAfterFormSubmit = async () => {
    return this.submissionHandler.handleAfterFormSubmit();
  };

  handleSubmit = async () => {
    return this.submissionHandler.handleSubmit();
  };

  isAuthenticated = async () => {
    return AuthenticationManager.isAuthenticated();
  };

  uploadFileAndUpdateAnswer = async (value, reqId) => {
    return this.fileUploadHandler.uploadFileAndUpdateAnswer(value, reqId);
  };

  traverseAndFlatten = async (currentNode, action, reqId, failedUploads) => {
    return this.fileUploadHandler.traverseAndFlatten(
      currentNode,
      action,
      reqId,
      failedUploads
    );
  };

  uploadFile = async (files, reqId) => {
    return this.fileUploadHandler.uploadFile(files, reqId);
  };

  zipAndUploadFile = async (files, reqId, zipName) => {
    return this.fileUploadHandler.zipAndUploadFile(files, reqId, zipName);
  };

  handleErrorState(error) {
    return this.errorHandler.handleErrorState(error);
  }

  getCookie(name) {
    return this.dataManager.getCookie(name);
  }

  processIdToken = () => {
    return AuthenticationManager.processIdToken();
  };

  checkCanExecute() {
    return AuthenticationManager.checkCanExecute(
      this.props.match.params.form_id,
      this.props.history,
      this.setState.bind(this)
    );
  }

  initData(idToken) {
    let getSessionPromise = Promise.resolve(1);
    let isIncludeSingleUseForm = false;
    const isTest = this.props.match.params.test_id !== undefined;

    if (
      this.props.match.params.session_id &&
      this.props.match.params.session_id.trim() !== ''
    ) {
      isIncludeSingleUseForm = true;

      if (this.props.match.params.test_id !== undefined) {
        getSessionPromise = axios(
          config.API_ADDRESS +
            API_ENDPOINTS.TEST_FORM_SESSION +
            '?form_id=' +
            this.props.match.params.form_id +
            '&session_id=' +
            this.props.match.params.session_id,
          {
            method: 'get',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: idToken,
            },
          }
        );
      } else {
        getSessionPromise = axios(
          config.API_ADDRESS +
            API_ENDPOINTS.FORM_SESSION +
            '?form_id=' +
            this.props.match.params.form_id +
            '&session_id=' +
            this.props.match.params.session_id,
          {
            method: 'get',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: idToken,
            },
          }
        );
      }
      this.props.dispatchFetchFormComments({
        session_id: this.props.match.params.session_id,
        isTest,
      });
    }

    getSessionPromise
      .then((formSession) => {
        let projectVersion = 0;
        let projectSessionId = undefined;
        let latestTestProjectSessionId = null;
        let parentThreadId = null;
        let threadId = null;
        let waitingStateThreadId = null;
        let waitingStateParentThreadId = null;
        let submissionId = '';
        let session_id = '';
        let lastSaved = null;

        if (formSession && formSession.data && formSession.data.data) {
          this.setHasBeenSubmitted(formSession);
          if (formSession.data.data.canReadOnly !== undefined) {
            this.setState({ canReadOnly: formSession.data.data.canReadOnly });
          }
          this.setState({ submissionId: formSession.data.data.submissionId });

          if (formSession.data.data.threadId != null) {
            parentThreadId = formSession.data.data.parentThreadId;
            threadId = formSession.data.data.threadId;
          }

          waitingStateThreadId = formSession.data.data.waitingStateThreadId
            ? formSession.data.data.waitingStateThreadId
            : null;
          waitingStateParentThreadId = formSession.data.data
            .waitingStateParentThreadId
            ? formSession.data.data.waitingStateParentThreadId
            : null;
          projectVersion = formSession.data.data.projectVersion;
          projectSessionId = formSession.data.data.projectSessionId;
          latestTestProjectSessionId =
            formSession.data.data.latestTestProjectSessionId;
          submissionId = formSession.data.data.submissionId;
          session_id = formSession.data.data.session_id;
          lastSaved = formSession.data.data.update_at;
        }

        if (
          this.props.match.path &&
          this.props.match.path.includes('form_preview') &&
          projectVersion === 0
        ) {
          this.setState({ previewMode: true });
          projectVersion = this.props.match.params.projectVersion;
          isIncludeSingleUseForm = true;
        }

        let isLatestDraft;
        if (isTest) {
          isLatestDraft = QUERY_PARAMS.IS_LATEST_DRAFT;
        } else {
          isLatestDraft = '';
        }

        if (latestTestProjectSessionId !== null && isTest) {
          axios(
            config.API_ADDRESS +
              API_ENDPOINTS.TEST_RESULT_WITH_SESSION_ID +
              '?projectSessionId=' +
              latestTestProjectSessionId,
            {
              method: 'get',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          ).then((res) => {
            const data = res.data;
            const { testResult } = data;
            this.setState({ testResult });
          });
        }

        axios(
          config.API_ADDRESS +
            API_ENDPOINTS.FORM_META +
            '?form_id=' +
            this.props.match.params.form_id +
            `${QUERY_PARAMS.SESSION_ID}${session_id}` +
            `${QUERY_PARAMS.IS_TEST}${isTest}` +
            QUERY_PARAMS.INCLUDE_SINGLE_USE_FORM +
            isIncludeSingleUseForm +
            QUERY_PARAMS.PROJECT_VERSION +
            projectVersion +
            `${QUERY_PARAMS.PROJECT_SESSION_ID}${projectSessionId}` +
            `${QUERY_PARAMS.THREAD_ID}${threadId}` +
            `${QUERY_PARAMS.SUBMISSION_ID}${submissionId}` +
            isLatestDraft,
          {
            method: 'get',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: idToken,
            },
          }
        )
          .then(async (res) => {
            let data = res.data.data;

            if (data && data.pages) {
              let pageKeys = Object.keys(data.pages);

              pageKeys.forEach((aPageKey, index) => {
                let pageTitle =
                  DEFAULT_VALUES.DEFAULT_PAGE_TITLE + ' ' + (index + 1);

                let aPage = data.pages[aPageKey];

                // v2: page.title is a string; v1: page.title.view.data.default
                const pageTitleValue =
                  (typeof aPage.title === 'string' ? aPage.title : null) ||
                  aPage.title?.view?.data?.default;

                if (pageTitleValue && pageTitleValue.trim() !== '') {
                  pageTitle = pageTitleValue.trim();
                }

                this.state.pagesMeta.push({ pageTitle: pageTitle });
              });
            }

            this.setState({
              form_logo: data.form_logo,
              form_title: data.formTitle || data.form_title,
              form_oauth2: data.form_oauth2,
              submMsg: data.submMsg,
              canAddSubmission: data.canAddSubmission,
              canSaveSubmission:
                data.canSaveSubmission !== undefined
                  ? data.canSaveSubmission
                  : true,
              canSubmitSubmission:
                data.canSubmitSubmission !== undefined
                  ? data.canSubmitSubmission
                  : true,
              canEditSubmission:
                data.canEditSubmission == null ? true : data.canEditSubmission,
              canReadOnly: this.state.canReadOnly,
              isSingleUse: data.isSingleUse,
              projectId: data.projectId,
              projectVersion: data.projectVersion,
              projectSessionId: projectSessionId,
              pagesMeta: this.state.pagesMeta,
              logo: data.logo,
              coverImage: data.coverImage,
              linkedComponent: data.linkedComponent,
              redirectToExternalUrl: data.redirectToExternalUrl || data.redirectAfterSubmit?.enabled || false,
              redirectUrl: data.redirectUrl || data.redirectAfterSubmit?.url || '',
              lastModified: data.lastModified,
              parentThreadId: parentThreadId,
              threadId: threadId,
              numRows: data.numRows,
              exportType: data.exportType,
              tableCells: data.tableCells,
              branding: data.branding,
              waitingStateThreadId: waitingStateThreadId,
              waitingStateParentThreadId: waitingStateParentThreadId,
              formType: data.formType,
              // Only set displayMode from data if not already set from URL
              ...(this.state.displayModeFromUrl
                ? {}
                : { displayMode: data.displayMode || 'classic' }),
              displayModeKnown: true,
              lastSaved: lastSaved,
              isTerminated: data.isTerminated,
              trueCanReadOnly: data.trueCanReadOnly,
            });
            // Update canReadOnly from form meta data
            if (data.canReadOnly !== undefined) {
              this.setState({
                canReadOnly: data.canReadOnly,
              });
            }

            projectVersion = data.projectVersion;
            return res;
          })
          .then(async (formMeta) => {
            this.autoSaveManager.handleAutoSave(formMeta, session_id);
            return formMeta;
          })
          .then((formMeta) => {
            // Merge URL prepopulation parameters with existing session data
            // Answer data is at formSession.data.data.data
            const existingAnswerData = formSession?.data?.data?.data || {};
            const prepopulatedAnswerData =
              getUrlPrepopulatedAnswerData(existingAnswerData);

            // Create a modified formSession with merged answer data
            // Preserve the existing session structure: formSession.data -> { data: { ...session fields, data: answer_data } }
            const formSessionWithPrepopulation = {
              ...formSession.data,
              data: {
                ...formSession?.data?.data,
                data: prepopulatedAnswerData,
              },
            };

            this.props.dispatchUpdateFormState(
              formSessionWithPrepopulation,
              formMeta.data
            );
          })
          .then(() => {
            if (!projectSessionId || projectSessionId === 'null') return;

            let reqData = {
              session_id: projectSessionId,
              component_id: this.props.match.params.form_id,
              thread_id: threadId,
              user: this.state.username,
            };

            axios(`${config.API_ADDRESS}${API_ENDPOINTS.SAVE_TASK_LOADED}`, {
              method: 'post',
              data: reqData,
            })
              .then(() => console.log('Successfully saved task load'))
              .catch((e) => console.log(e));
          })
          .catch((e) => {
            this.handleFormError(e);
          });
      })
      .then(async () => {})
      .catch((e) => {
        this.handleFormError(e);
      });
  }

  setHasBeenSubmitted = (session) => {
    try {
      let by = session.data.data.data.submittedBy;

      if (by.displayName !== null || by.userName !== null)
        this.setState({ hasBeenSubmitted: true });
      else this.setState({ hasBeenSubmitted: false });
    } catch (e) {
      this.setState({ hasBeenSubmitted: false });
    }
  };

  handleFormError = (e) => {
    return this.errorHandler.handleFormError(e);
  };

  componentDidMount = async () => {
    await this.setTimezone();
    this.setState({ form_id: this.props.match.params.form_id });

    // Check for displayMode URL parameter (overrides saved setting)
    this.checkDisplayModeFromUrl();

    this.checkForReturnFromAuthentication();

    try {
      let idToken = await this.processIdToken();
      this.initData(idToken);
    } catch (e) {
      console.log(e);
    }
  };

  checkDisplayModeFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const modeParam = urlParams.get('mode') || urlParams.get('displayMode');
    if (
      modeParam &&
      (modeParam === 'classic' || modeParam === 'conversational')
    ) {
      this.setState({
        displayMode: modeParam,
        displayModeFromUrl: true,
        displayModeKnown: true,
      });
    }
  };

  checkForReturnFromAuthentication = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const loginSuccess = urlParams.get('loginSuccess');
    const token = urlParams.get('token');
    const returnUrl = localStorage.getItem('form_return_url');

    if (loginSuccess === 'true' || token) {
      console.log('User returned from successful authentication');
      window.history.replaceState({}, document.title, window.location.pathname);
      localStorage.removeItem('form_return_url');
      sessionStorage.removeItem('unified_login_attempted'); // Clear unified login attempt flag
      this.setState({ authState: 'signedIn' });
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (returnUrl && returnUrl === window.location.href) {
      console.log('User returned to correct form URL');
      localStorage.removeItem('form_return_url');
      sessionStorage.removeItem('unified_login_attempted'); // Clear unified login attempt flag
      this.checkIfAlreadyAuthenticated();
    }
  };

  checkIfAlreadyAuthenticated = async () => {
    try {
      const isAuth = await AuthenticationManager.isAuthenticated();
      if (isAuth) {
        console.log('User is already authenticated, loading form');
        this.setState({ authState: 'signedIn' });
      }
    } catch (error) {
      console.log('Authentication check failed:', error);
    }
  };

  /**
   * Check if user is authenticated on app.workflow86.com domain first
   * This prevents unnecessary authentication challenges when user is already logged in to the main app
   */
  checkCrossDomainAuthentication = async () => {
    try {
      // Skip cross-domain check if we're returning from authentication or user is already signed in locally
      const urlParams = new URLSearchParams(window.location.search);
      const isReturningFromAuth =
        urlParams.get('loginSuccess') || urlParams.get('token');
      const isLocallyAuthenticated =
        await AuthenticationManager.isAuthenticated();
      const hasAttemptedUnifiedLogin = sessionStorage.getItem(
        'unified_login_attempted'
      );

      if (
        isReturningFromAuth ||
        isLocallyAuthenticated ||
        hasAttemptedUnifiedLogin
      ) {
        console.log(
          'Skipping cross-domain check - already authenticated, returning from auth, or already attempted unified login'
        );
        return;
      }

      // Check if this is a same-domain scenario (no cross-domain work needed)
      if (window.self !== window.top) {
        const currentDomain = window.location.hostname;
        const parentDomain = new URL(config.ADMIN_DASHBOARD_URL).hostname;

        const getBaseDomain = (domain) => {
          const parts = domain.split('.');
          return parts.length >= 2 ? parts.slice(-2).join('.') : domain;
        };

        const currentBaseDomain = getBaseDomain(currentDomain);
        const parentBaseDomain = getBaseDomain(parentDomain);

        if (currentBaseDomain === parentBaseDomain) {
          console.log(
            `Same domain (${currentBaseDomain}) - letting Cognito handle session sharing naturally`
          );
          return; // No cross-domain work needed, let normal auth flow handle it
        }
      }

      console.log(
        `Checking authentication status on ${config.ADMIN_DASHBOARD_URL}...`
      );
      const isAppAuthenticated =
        await AuthenticationManager.checkAppWorkflowAuthentication();

      if (isAppAuthenticated) {
        console.log(
          `User is authenticated on ${config.ADMIN_DASHBOARD_URL}, initiating unified login...`
        );
        // Store flag to prevent infinite redirects
        sessionStorage.setItem('unified_login_attempted', 'true');
        await AuthenticationManager.initiateUnifiedLogin();
      } else {
        console.log(
          `User is not authenticated on ${config.ADMIN_DASHBOARD_URL}`
        );
        // Clear any previous attempt flags since user is not authenticated anywhere
        sessionStorage.removeItem('unified_login_attempted');
      }
    } catch (error) {
      console.error('Cross-domain authentication check failed:', error);
      // Clear any previous attempt flags on error
      sessionStorage.removeItem('unified_login_attempted');
    }
  };

  setTimezone = async () => {
    return AuthenticationManager.setTimezone(this.setState.bind(this));
  };

  componentWillUnmount() {
    this.props.dispatchUnmountForm();
    this.autoSaveManager.clearInterval();
  }

  componentSelector = (format, data, section, key) => {
    return this.componentRenderer.componentSelector(format, data, section, key);
  };

  getDataFromComponent = (
    data,
    key,
    question_text,
    answer_list,
    outputFormat,
    timezone,
    tableAnswerKeys,
    exportFormat
  ) => {
    return this.dataManager.getDataFromComponent(
      data,
      key,
      question_text,
      answer_list,
      outputFormat,
      timezone,
      tableAnswerKeys,
      exportFormat
    );
  };
  unWrap_answer = (data, container, current_deepth) => {
    return this.dataManager.unWrap_answer(data, container, current_deepth);
  };

  checkAllAnswerOnAllPages = () => {
    const isValidationEnabled = this.state.isTest
      ? this.state.isValidationEnabled
      : true;
    return FormValidator.checkAllAnswerOnAllPages(
      this.props.form,
      this.state.pagesMeta,
      (stateUpdate) => this.setState(stateUpdate),
      isValidationEnabled
    );
  };

  doCheckAllAnswers = (pageIndex) => {
    const isValidationEnabled = this.state.isTest
      ? this.state.isValidationEnabled
      : true;
    return FormValidator.doCheckAllAnswers(
      pageIndex,
      this.props.form,
      this,
      isValidationEnabled
    );
  };

  doCheckTableAnswers = (pageIndex) => {
    const isValidationEnabled = this.state.isTest
      ? this.state.isValidationEnabled
      : true;
    return FormValidator.doCheckTableAnswers(
      pageIndex,
      this.props.form,
      isValidationEnabled
    );
  };

  getRowName = (rowLabels, row) => {
    return FormValidator.getRowName(rowLabels, row);
  };

  checkAllTableRequired = (cols, tableAns, tableCells, rowLabels) => {
    return FormValidator.checkAllTableRequired(
      cols,
      tableAns,
      tableCells,
      rowLabels
    );
  };
  clearDeletedFields = () => {
    FormValidator.clearDeletedFields(this.props.match.params, this.props.form);
  };

  checkAllAnswered = (pageIndex) => {
    const isValidationEnabled = this.state.isTest
      ? this.state.isValidationEnabled
      : true;
    return FormValidator.checkAllAnswered(
      pageIndex,
      this.props.form,
      this,
      (stateUpdate) => this.setState(stateUpdate),
      isValidationEnabled
    );
  };

  handlePageLoad = async () => {
    return this.dataManager.handlePageLoad();
  };

  handleOpenAnnotation = async () => {};

  handleOpenSidebar = () => {};

  handleNext = async (event, pageIndex) => {
    return this.navigationHandler.handleNext(event, pageIndex);
  };

  handleBack = async () => {
    return this.navigationHandler.handleBack();
  };

  handleToHome = () => {
    return this.navigationHandler.handleToHome();
  };

  getDisplayName = (data) => {
    return this.dataManager.getDisplayName(data);
  };

  saveUsageService = async () => {};

  handleSaveProgress = async (showSaveDialog) => {
    return this.autoSaveManager.handleSaveProgress(showSaveDialog);
  };

  makeFormSaveRequest = async (sessionURL, data, session_id) => {
    return this.autoSaveManager.makeFormSaveRequest(
      sessionURL,
      data,
      session_id
    );
  };

  handleSaveWhenNextOrBack = async () => {
    this.saveUsageService();
    const { session_id, form_id } = this.props.match.params;
    const { answer_data } = this.props.form;
    const { password } = this.state;

    this.setState({ pageProcessing: true });

    const data = await this.traverseAndFlatten(answer_data, 'SAVE');
    const url = `${config.API_ADDRESS}${API_ENDPOINTS.FORM_SESSION}?session_id=${session_id}&form_id=${form_id}`;
    axios(url, {
      method: 'post',
      data: {
        data: data,
        session_id,
        form_id,
        password,
        projectSessionId: this.state.projectSessionId,
        projectVersion: this.state.projectVersion,
        isSingleUse: this.state.isSingleUse,
        submissionId: this.state.submissionId,
      },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((e) => {
        this.setState({ pageProcessing: false });
      })
      .catch((e) => {
        alert(e.response.data.msg);
      });
  };

  isContain = (data, container) => {
    return this.dataManager.isContain(data, container);
  };

  closeAlert = () => {
    return this.errorHandler.closeAlert();
  };

  handleMenuOpen = (event) => {
    this.setState({
      openMainMenu: true,
      anchorEl: event.currentTarget,
    });
  };

  handleMenuClose = () => {
    this.setState({
      openMainMenu: false,
      anchorEl: null,
    });
  };

  render() {
    const { classes, form } = this.props;
    const { test_id } = this.props.match.params;
    const { coverImage } = this.state;
    const isTest = test_id !== undefined;
    const readOnly = this.state.canReadOnly && !isTest;

    if (this.state.receiptState !== 'hidden') {
      return (
        <Grid
          container
          direction="row"
          justifyContent="center"
          className="gridStyle"
        >
          <SubmissionReceipt
            submissionState={this.state.receiptState}
            formId={this.props.match.params.form_id}
            sessionId={this.props.match.params.session_id}
            testId={this.props.match.params.test_id}
            isSingleUse={this.state.isSingleUse}
            submMsg={this.state.submMsg}
            canAddSubmission={this.state.canAddSubmission}
            canEditSubmission={this.state.canEditSubmission}
            canReadOnly={this.state.canReadOnly}
            formType={this.state.formType}
            redirectUrl={this.state.redirectUrl}
            onBack={() => {
              this.setState({ receiptState: 'hidden' });
            }}
          />
        </Grid>
      );
    }

    try {
      if (
        this.state.authState !== 'signedIn' &&
        this.state.form_oauth2 !== undefined &&
        this.state.form_oauth2 !== 'undefined' &&
        this.state.form_oauth2 !== '' &&
        this.state.form_oauth2 !== null
      ) {
        return (
          <AuthenticationGate
            authState={this.state.authState}
            form_oauth2={this.state.form_oauth2}
            updateUsername={this.updateUsername}
          />
        );
      }

      if (form.isReady === true) {
        const page_data = form.request_data[form.current_index];

        // Safety check: if page_data is undefined, show loading
        if (!page_data) {
          if (this.state.displayMode === 'conversational') {
            return <ConversationalSkeletonLoader />;
          }
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
              }}
            >
              <CircularProgress />
            </div>
          );
        }

        // v2: page_data.title is a string; v1: page_data.title.view.data.default
        const pageTitleText =
          (typeof page_data.title === 'string' ? page_data.title : null) ||
          page_data.title?.view?.data?.default;

        let Title_component = this.componentSelector(
          page_data.title?.view?.format || 'row_text',
          {
            data: dynamicRender(
              this,
              pageTitleText,
              page_data.title?.view?.data?.dynamic
            ),
            style: page_data.title?.view?.style,
          },
          'title',
          form.current_index
        );

        const title = pageTitleText;

        return (
          <>
            <FormStatusBanners
              readOnly={readOnly}
              isTest={this.state.isTest}
              isTerminated={this.state.isTerminated}
            />
            <Helmet>
              <title>
                {this.state.form_title
                  ? this.state.form_title
                  : DEFAULT_VALUES.UNTITLED_FORM}{' '}
                | {DEFAULT_VALUES.APP_NAME}
              </title>
            </Helmet>
            <FormHeaderComponent
              formTitle={this.state.form_title}
              formLogo={this.state.form_logo}
              hasAutoSaveEnabled={this.state.hasAutoSaveEnabled}
              canSaveSubmission={this.state.canSaveSubmission}
              isTest={this.state.isTest}
              readOnly={readOnly}
              pageProcessing={this.state.pageProcessing}
              previewMode={this.state.previewMode}
              sended={this.state.sended}
              isTerminated={this.state.isTerminated}
              openMainMenu={this.state.openMainMenu}
              anchorEl={this.state.anchorEl}
              pagesMeta={this.state.pagesMeta}
              visitedPages={this.visitedPages}
              currentIndex={form.current_index}
              onSave={() => this.handleSaveProgress(true)}
              onMenuToggle={this.handleMenuOpen}
              onMenuClose={this.handleMenuClose}
              onPageNavigation={this.handleNext}
              className="app-bar"
            />
            <Grid>
              {coverImage !== undefined &&
              coverImage !== '' &&
              coverImage?.uploaded?.id !== undefined ? (
                <div className="form-cover-image">
                  <CoverImage coverImage={coverImage} />
                </div>
              ) : (
                ''
              )}
            </Grid>
            <div style={this.state.isTest ? { paddingBottom: '70px' } : {}}>
                  {this.state.displayMode === 'conversational' ? (
                    /* Conversational layout - one question at a time */
                    <div className="conv-wrapper">
                      {form.loading ? (
                        <ConversationalSkeletonLoader />
                      ) : (
                        <ConversationalRenderer
                          pageData={page_data}
                          form={this.props.form}
                          formInstance={this}
                          componentRenderer={this.componentRenderer}
                          readOnly={readOnly}
                          timezone={this.state.timezone}
                          requiredList={this.state.required_list}
                          requiredListTable={this.state.required_list_table}
                          username={this.state.username}
                          sended={this.state.sended}
                          pageProcessing={this.state.pageProcessing}
                          previewMode={this.state.previewMode}
                          onAnswerChange={this.getDataFromComponent}
                          onSubmit={this.handleSubmit}
                          onNext={this.handleNext}
                          onBack={this.handleBack}
                          onGoToPage={this.handleToPage}
                          currentPageIndex={parseInt(form.current_index, 10)}
                          totalPages={parseInt(form.form_length, 10)}
                          pageTitles={Object.keys(form.request_data).map(
                            (key) => {
                              const pg = form.request_data[key];
                              return (typeof pg?.title === 'string' ? pg.title : null) ||
                                pg?.title?.view?.data?.default ||
                                `Page ${parseInt(key, 10) + 1}`;
                            }
                          )}
                          isLastPage={
                            parseInt(form.current_index, 10) ===
                            parseInt(form.form_length, 10) - 1
                          }
                          canSubmitSubmission={this.state.canSubmitSubmission}
                          hasBeenSubmitted={this.state.hasBeenSubmitted}
                          isSubmitting={this.state.isSubmitting}
                        />
                      )}
                      <FormFooterComponent
                        projectVersion={this.state.projectVersion}
                        lastModified={this.state.lastModified}
                        timezone={this.state.timezone}
                        branding={this.state.branding}
                      />
                    </div>
                  ) : (
                    /* Classic layout - all questions on page */
                    <FormLayoutWrapper
                      classes={classes}
                      alertOpen={this.state.AlertD}
                      alertMessage={this.state.AlertMsg}
                      onAlertClose={this.closeAlert}
                      lastSaved={this.state.lastSaved}
                      navigationComponent={
                        <NavigationMenu
                          pagesMeta={this.state.pagesMeta}
                          visitedPages={this.visitedPages}
                          handleNext={this.handleNext}
                          form={this.props.form}
                          parsePlaceholder={parsePlaceholder}
                          processIdToken={this.processIdToken}
                          projectSessionId={
                            this.state.projectSessionId
                              ? this.state.projectSessionId
                              : this.state.submissionId
                          }
                          formId={this.props.match.params.form_id}
                          formTitle={this.state.form_title}
                          handleSaveProgress={this.handleSaveProgress}
                          isSaving={this.state.pageProcessing}
                          showResubmitDialog={this.state.showResubmitDialog}
                          closeResubmitDialog={() => {
                            this.setState({ showResubmitDialog: false });
                          }}
                          handleSubmit={this.handleSubmit}
                          timezone={this.state.timezone}
                          threadId={this.state.threadId}
                          readOnly={readOnly}
                          isTest={this.state.isTest}
                        />
                      }
                    >
                      {
                        <div className="descriptionDiv">
                          {form.loading && (
                            <div>
                              <CircularProgress
                                size={SIZE_CONSTANTS.CIRCULAR_PROGRESS_LARGE}
                              />
                            </div>
                          )}
                          <FadeIn>
                            {!form.loading && (
                              <div className="descriptionTitle" id="title-area">
                                {Title_component}
                                {
                                  <p className="page-title-description">
                                    {dynamicRender(
                                      this,
                                      (typeof page_data.title === 'string' ? page_data.description : page_data.title?.description?.default) || '',
                                      typeof page_data.title === 'string' ? page_data.dynamicDescription : page_data.title?.description?.dynamic
                                    )}
                                  </p>
                                }
                              </div>
                            )}

                            {!form.loading && (
                              <FormQuestionRenderer
                                pageData={page_data}
                                form={this.props.form}
                                formInstance={this}
                                componentRenderer={this.componentRenderer}
                                readOnly={readOnly}
                                timezone={this.state.timezone}
                                requiredList={this.state.required_list}
                                requiredListTable={
                                  this.state.required_list_table
                                }
                                username={this.state.username}
                                sended={this.state.sended}
                                pageProcessing={this.state.pageProcessing}
                                previewMode={this.state.previewMode}
                                onAnswerChange={this.getDataFromComponent}
                              />
                            )}

                            <div>
                              <FormNavigationButtons
                                currentIndex={form.current_index}
                                formLength={form.form_length}
                                isLoading={this.state.pageProcessing}
                                isSubmitting={this.state.isSubmitting}
                                sended={this.state.sended}
                                onBack={this.handleBack}
                                onNext={this.handleNext}
                                onSubmit={this.handleSubmit}
                                onToHome={this.handleToHome}
                                showSubmitSection={true}
                                showBackButton={true}
                                showNextButton={true}
                                canSubmitSubmission={
                                  this.state.canSubmitSubmission
                                }
                                hasBeenSubmitted={this.state.hasBeenSubmitted}
                                readOnly={readOnly}
                                previewMode={this.state.previewMode}
                                isTest={this.state.isTest}
                                openResubmitDialog={() =>
                                  this.setState({ showResubmitDialog: true })
                                }
                              />
                            </div>
                          </FadeIn>
                        </div>
                      }

                      <FormFooterComponent
                        projectVersion={this.state.projectVersion}
                        lastModified={this.state.lastModified}
                        timezone={this.state.timezone}
                        branding={this.state.branding}
                      />
                    </FormLayoutWrapper>
                  )}
                </div>
            <div
              className={`preview-footer ${this.state.previewMode ? 'show' : ''} ${classes.footerPreview}`}
            >
              <p className="preview-footer-text">
                {UI_TEXT.PREVIEW_MODE_MESSAGE}
              </p>
            </div>
            <FormDialogManager
              saveDialog={this.state.saveDialog}
              showSubmissionDialog={this.state.showSubmissionDialog}
              showFailedSubmissionDialog={this.state.showFailedSubmissionDialog}
              pagesErrorDialog={this.state.pagesErrorDialog}
              isSubmitting={this.state.isSubmitting}
              formFailures={this.state.formFailures}
              pagesError={this.state.pagesError}
              formState={{ ...this.state }}
              onCloseSaveDialog={() => {
                this.setState({ saveDialog: false, formFailures: {} });
              }}
              onCloseSubmissionDialog={() =>
                this.setState({ showSubmissionDialog: false })
              }
              onCloseFailedSubmissionDialog={() =>
                this.setState({
                  showFailedSubmissionDialog: false,
                  formFailures: {},
                })
              }
              onClosePagesErrorDialog={() => {
                this.setState({ pagesErrorDialog: false });
              }}
            />
            <RequiredFieldsSnackbar
              open={this.state.showRequiredFieldsSnackbar}
              requiredList={this.state.required_list}
              requiredListTable={this.state.required_list_table}
              onClose={() =>
                this.setState({ showRequiredFieldsSnackbar: false })
              }
            />
            {/* Test Mode Controls - Floating Panel */}
            {this.state.isTest && (
              <TestModeControls
                isValidationEnabled={this.state.isValidationEnabled}
                onValidationToggle={this.handleValidationToggle}
              />
            )}
          </>
        );
      } else {
        // Show neutral spinner until we know the display mode
        if (!this.state.displayModeKnown) {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                gap: '20px',
                background: '#fafafa',
              }}
            >
              <CircularProgress
                size={32}
                thickness={3}
                sx={{
                  color: '#1a1a1a',
                }}
              />
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#666',
                  letterSpacing: '0.3px',
                }}
              >
                Loading form
              </span>
            </div>
          );
        }
        if (this.state.displayMode === 'conversational') {
          return <ConversationalSkeletonLoader />;
        }
        return <FormSkeletonLoader classes={classes} />;
      }
    } catch (e) {
      console.log(e);
      if (this.state.displayMode === 'conversational') {
        return <ConversationalSkeletonLoader />;
      }
      return <FormSkeletonLoader classes={classes} />;
    }
  }

  addAnnotationHighlights = async () => {};

  showSidebarAndHighlight = () => {};

  setStateAsync(state) {
    return this.dataManager.setStateAsync(state);
  }

  updateUsername = (username) => {
    this.setState({ username });
  };

  handleValidationToggle = (isEnabled) => {
    this.setState({ isValidationEnabled: isEnabled });
  };
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
    loading: state.form.loading,
  };
};

const mapDispatchToProps = {
  dispatchfetchNextPage: (
    password,
    form_id,
    index,
    projectVersion,
    projectSessionId,
    threadId
  ) =>
    fetchNextPageData({
      password,
      form_id,
      index,
      projectVersion,
      projectSessionId,
      threadId,
    }),
  dispatchgoBackToPrevious: () => goBackToPrevious(),
  dispatchaddPageData: (key, answer, question_text, format) =>
    addPageData({ key, answer, question_text, format }),
  dispatchaddPageDataCalendar: (
    key,
    answer,
    question_text,
    format,
    rawValue,
    outputFormat,
    timezone
  ) =>
    addPageDataCalendar({
      key,
      answer,
      question_text,
      format,
      rawValue,
      outputFormat,
      timezone,
    }),
  dispatchaddPageDataTable: (
    key,
    answer,
    question_text,
    format,
    exportFormat,
    tableAnswerKeys,
    colNames
  ) =>
    addPageDataTable({
      key,
      answer,
      question_text,
      format,
      exportFormat,
      tableAnswerKeys,
      colNames,
    }),
  dispatchUnmountForm: () => unmountForm(),
  dispatchgoBackToANY: (index) => goBackToANY(index),
  dispatchFormLoading: () => formLoading(),
  dispatchFetchFormComments: (session_id, isTest = false) =>
    fetchFormComments(session_id, isTest),
  dispatchUpdateFormState: (formSession, formMeta) =>
    updateFormState({
      formSession,
      formMeta,
    }),
};

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withNavigate(Form)));
